var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-dialog',{attrs:{"visible":_vm.isShow},on:{"update:visible":function($event){_vm.isShow=$event}}},[_c('div',[_c('img',{attrs:{"width":"780","height":"400","src":_vm.teamDetail.icon}})]),_c('div',{staticClass:"content ql-snow ql-editor",domProps:{"innerHTML":_vm._s(_vm.teamDetail.introduction)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }